<template>
  <div class="container">
    <div>
      <div class="p-3">
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>
        <div v-if="!loading">
            <div v-if="!isAuthorized"  class="notification is-danger is-light">
              You are not authorized to view this trip.
            </div>
            <!-- Authorized to view trip details -->
            <div v-else>
              <div class="mb-5" v-if="capability.can_display">
                <router-link to="/planned-trips" class="has-text-weight-bold">Trips</router-link>
                >
                <span class="has-text-weight-light">Trip Details</span>
              </div>
              <b-icon icon="arrow_left" size=""></b-icon>

              <div class="mb-5" :class="capability.can_display ? 'box p-5' : ''">
                <div class="columns is-centered">
                  <div class="column">
                    <div class="columns">
                      <div class="column is-two-thirds">
                        <div class="columns is-centered is-mobile" v-if="capability.can_display">
                          <div class="column is-narrow mt-1">
                            <b-icon icon="wallet-travel mt-2" size="is-medium"></b-icon>
                          </div>
                          <div class="column">
                            <div class="is-size-3 mb-3 has-text-weight-medium">
                              Your Trip:
                            </div>
                          </div>
                          <!-- Actions Menu -->
                          <div class="column is-narrow"  v-if="capability.can_cancel && hasActiveTripSegment" >
                            <b-button label="Manage Trip" @click="pushToTripCancel()" />
                          </div>
                        </div>
                        <!-- /Actions Menu -->
                        <!-- Approval Pending / Denied Message-->
                        <b-message :type="timelineClass" v-if="timelineMessage" class="mt-6">
                          {{ timelineMessage }}
                        </b-message>
                        <!-- //Approval Pending / Denied Message-->

                        <TripSummary :trip="trip" class="mb-6 is-hidden-tablet" v-if="trip.tripSummary" />

                        <TripBookingProgress :trip="trip" v-if="trip.tripProgress" class="is-hidden-tablet mb-6" />

                        <!-- Your Flights -->
                        <b-collapse aria-id="contentIdForA11y2" class="type-panel mb-6" animation="slide" v-if="tstInfo.length > 0 || cancelledflightSegments.length > 0
              ">
                          <template #trigger="props">
                            <div class="section-title is-size-4 has-text-weight-medium" role="button"
                              aria-controls="contentIdForA11y2">
                              <div class="columns is-mobile">
                                <div class="column">
                                  <span v-if="capability.can_display">Your</span>
                                  Flights
                                </div>
                                <div class="column is-narrow">
                                  <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'
              " size="is-medium" type="is-grey">
                                  </b-icon>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="section-body">
                            <NDCTag v-if="trip.isNdcBooking" class="mb-5" position="is-right"></NDCTag>

                            <div v-for="(tst, tstIndex) in trip.tstInfo" :key="tstIndex">
                              <div v-for="(journey, journeyIndex) in tst.journeys" :key="journeyIndex"
                                class="journey-segment">
                                <div class="notification is-info p-2 is-light">
                                  <span class="has-text-weight-semibold">
                                    {{
              $helpers.getAirportLocation(journey.stops[0])
            }}
                                    🠢
                                  </span>
                                  <span class="has-text-weight-semibold">
                                    {{
                $helpers.getAirportLocation(
                  journey.stops[journey.stops.length - 1]
                )
              }}
                                  </span>
                                </div>

                                <div v-for="(segment, index) in journey.segments" :key="index">
                                  <AirSegment :segment="segment" />
                                </div>
                              </div>

                              <div class="mb-3">
                                <div class="mb-3">
                                  Ticket Number:
                                  <span v-if="tst.ticketNumber">{{
              tst.ticketNumber
            }}</span>
                                  <span v-else class="has-text-weight-medium">Ticket Pending</span>
                                </div>

                                <div class="mb-4" v-if="tst.fare">
                                  Estimated Total:
                                  {{ tst.fare.total | formatPriceFromAmount(2, tst.fare.currency) }}
                                  <span class="has-text-grey">({{
              tst.fare.base | formatPriceFromAmount(2, tst.fare.currency)
            }}
                                    plus tax)</span>
                                </div>

                                <!-- <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                  @click="pushToFlightChange(tst)">
                                  Cancel Flight
                                </button> -->
                                <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                  @click="pushToTripCancel(tst.segments)">
                                  Cancel Flight
                                </button> 
                                

                                <button v-if="tst.ticketNumber" class="button is-primary is-small mt-2 mb-5 ml-4"
                                  @click="isModalOpen = true">
                                  Exchange Ticket
                                </button>

                                <b-modal v-model="isModalOpen" has-modal-card trap-focus :destroy-on-hide="false"
                                  aria-role="dialog" aria-label="Example Modal" close-button-aria-label="Close" aria-modal>
                                  <template #default="props">
                                    <AtcTicketCheck v-bind="{ trip, tst }" @close="props.close"></AtcTicketCheck>
                                  </template>
                                </b-modal>

                                <hr />
                              </div>
                            </div>

                            <div v-if="cancelledflightSegments.length">
                              <div class="my-5 is-size-6 has-text-primary-dark">
                                Cancelled Reservations:
                              </div>
                              <div v-for="(segment, index) in cancelledflightSegments" :key="index">
                                <AirCancelled :segment="segment" />
                              </div>
                            </div>
                          </div>
                        </b-collapse>

                        <!-- Your Hotel -->

                        <b-collapse aria-id="contentIdForA11y2" class="type-panel mb-6" animation="slide">
                          <template #trigger="props">
                            <div class="section-title is-size-4 has-text-weight-medium" role="button"
                              aria-controls="contentIdForA11y2">
                              <div class="columns is-mobile">
                                <div class="column">
                                  <span v-if="capability.can_display">Your</span>
                                  Hotel
                                </div>
                                <div class="column is-narrow">
                                  <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'
              " size="is-medium" type="is-grey">
                                  </b-icon>
                                </div>
                              </div>
                            </div>
                          </template>

                          <div class="section-body">
                            <div v-if="hotelSegments.length ||
              cancelledHotelSegments.length
              ">
                              <div v-if="hotelSegments.length">
                                <div v-for="(segment, index) in hotelSegments" :key="index">
                                  <HotelSegment :segment="segment" />
<!-- 
                                  <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                    @click="pushToSegmentCancel(segment)">
                                    Cancel
                                  </button> -->

                                  <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                  @click="pushToTripCancel(segment)">
                                  Cancel
                                </button> 
                                </div>
                              </div>

                              <div v-if="cancelledHotelSegments.length">
                                <div class="my-5 is-size-6 has-text-primary-dark">
                                  Cancelled Reservations:
                                </div>
                                <div v-for="(segment, index) in cancelledHotelSegments" :key="index">
                                  <HotelCancelled :segment="segment" />
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <i>It looks like you don't have a hotel reservation
                                for this trip yet. Want to add a hotel?</i>
                            </div>

                            <div class="columns">
                              <div class="column"></div>

                              <div class="column is-narrow">
                                <button v-if="capability.can_add" class="button is-primary mt-2 mb-5"
                                  @click="pushToHotelSearch">
                                  Add a hotel
                                </button>
                              </div>
                            </div>
                          </div>
                        </b-collapse>

                        <!-- Your Car -->
                        <b-collapse aria-id="contentIdForA11y2" class="type-panel mb-6" animation="slide">
                          <template #trigger="props">
                            <div class="section-title is-size-4 has-text-weight-medium" role="button"
                              aria-controls="contentIdForA11y2">
                              <div class="columns is-mobile">
                                <div class="column">
                                  <span v-if="capability.can_display">Your</span>
                                  Car
                                </div>
                                <div class="column is-narrow">
                                  <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'
              " size="is-medium" type="is-grey">
                                  </b-icon>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="section-body">
                            <div v-if="carSegments.length || cancelledCarSegments.length
              ">
                              <div v-if="carSegments.length">
                                <div v-for="(segment, index) in carSegments" :key="index">
                                  <CarSegment :segment="segment" />
<!--                                   <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                    @click="pushToSegmentCancel(segment)">
                                    Cancel
                                  </button> -->
                                  <button v-if="capability.can_cancel" class="button is-info is-small mt-2 mb-5"
                                  @click="pushToTripCancel(segment)">
                                  Cancel
                                </button>
                                </div>
                              </div>
                              <div v-if="cancelledCarSegments.length">
                                <div class="my-5 is-size-6 has-text-primary-dark">
                                  Cancelled Reservations:
                                </div>
                                <div v-for="(segment, index) in cancelledCarSegments" :key="index">
                                  <CarCancelled :segment="segment" />
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <i>It looks like you don't have a car reservation for
                                this trip yet. Want to add a car?</i>
                            </div>
                            <div class="columns">
                              <div class="column"></div>

                              <div class="column is-narrow">
                                <button v-if="capability.can_add" class="button is-primary is-primary mt-2 mb-5"
                                  @click="pushToCarSearch">
                                  Add a car
                                </button>
                              </div>
                            </div>
                          </div>
                        </b-collapse>
                      </div>

                      <div class="column is-hidden-mobile">
                        <TripSummary :trip="trip" :is-editable="capability.can_add" v-if="trip.tripSummary" />

                        <TripBookingProgress :trip="trip" v-if="trip.tripProgress" class="mt-6" />

                        <div class="type-panel p-6 mt-6 has-text-centered" v-if="capability.can_display">
                          <img src="/images/undraw_travel_mode.svg" style="width:150px" />

                          <div class="">
                            <h2 class="is-size-4 has-text-weight-semibold">
                              Booking made easy
                            </h2>
                            <p class="py-2">
                              Booking your Trip through TripCircuit is a safe and
                              secure way to book corporate travel, and you'll also
                              enjoy these added benefits:
                            </p>
                            <ul class="list-unstyled py-2 has-text-left">
                              <li class="">
                                <span class="li__icon">
                                  <span class="SVGIcon SVGIcon--24px">
                                    <svg data-id="SVG_CHECK__24" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                      width="24" height="24" fill="none" viewBox="0 0 24 24">
                                      <path stroke="currentColor" d="M21.152 5.818L10.385 18.181l-6.233-6.18"></path>
                                    </svg>
                                  </span>
                                </span>
                                <span class="li__content">Enjoy the convenience of online booking, backed
                                  by full service Gant Travel Management
                                </span>
                              </li>
                              <li class="">
                                <span class="li__icon">
                                  <span class="SVGIcon SVGIcon--24px">
                                    <svg data-id="SVG_CHECK__24" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                      width="24" height="24" fill="none" viewBox="0 0 24 24">
                                      <path stroke="currentColor" d="M21.152 5.818L10.385 18.181l-6.233-6.18"></path>
                                    </svg>
                                  </span>
                                </span>
                                <span class="li__content">We're always here for you with 24/7 customer
                                  service
                                </span>
                              </li>
                              <li class="">
                                <span class="li__icon">
                                  <span class="SVGIcon SVGIcon--24px">
                                    <svg data-id="SVG_CHECK__24" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                      width="24" height="24" fill="none" viewBox="0 0 24 24">
                                      <path stroke="currentColor" d="M21.152 5.818L10.385 18.181l-6.233-6.18"></path>
                                    </svg>
                                  </span>
                                </span>
                                <span class="li__content">TripCircuit integrates seamlessly with your
                                  existing corporate travel policies and reporting
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>   
            </div>
             <!-- //Authorized to view trip details -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AtcTicketCheck from "@/components/BookTravel/Air/AtcTicketCheck.vue";
import AirSegment from "@/components/Trip/AirSegment.vue";
import AirCancelled from "@/components/Trip/AirCancelled.vue";
import CarSegment from "@/components/Trip/CarSegment.vue";
import CarCancelled from "@/components/Trip/CarCancelled.vue";
import HotelSegment from "@/components/Trip/HotelSegment.vue";
import HotelCancelled from "@/components/Trip/HotelCancelled.vue";
import TripSummary from "@/components/Trip/TripSummary.vue";
import NDCTag from "@/components/Tags/NDCTag.vue";
import router from "@/router";
import TripBookingProgress from "../components/Trip/TripBookingProgress.vue";
export default {
  name: "TripDetails",
  components: {
    AirSegment,
    CarSegment,
    HotelSegment,
    AirCancelled,
    HotelCancelled,
    CarCancelled,
    TripSummary,
    AtcTicketCheck,
    NDCTag,
    TripBookingProgress,
  },
  props: {
    //a base64 encoded version of the actual Amadeus record locator;
    //used in the url for obscurity
    recordLocatorHash: {
      required: true,
      type: String,
    },
    tripProp: {
      required: false,
      //type: Object,
    },
    source: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      trip: {},
      error: {},
      loading: false,
      isModalOpen: false,
      isAuthorized: true,
    };
  },
  computed: {
    //convert the Base64 hash to the actual Amadeus record locator
    recordLocator() {
      return this.$helpers.decryptText(this.recordLocatorHash);
    },
    flightSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "air" && segment.status != "cancelled"
      );
    },
    carSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "car" && segment.status != "cancelled"
      );
    },
    hotelSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "hotel" && segment.status != "cancelled"
      );
    },
    cancelledflightSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "air" && segment.status == "cancelled"
      );
    },
    cancelledCarSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "car" && segment.status == "cancelled"
      );
    },
    cancelledHotelSegments() {
      return (this.trip.segments || []).filter(
        (segment) => segment.type == "hotel" && segment.status == "cancelled"
      );
    },
    tstInfo() {
      return this.trip.tstInfo ?? [];
    },
    capability() {
      let capability = {
        can_cancel: false,
        can_add: false,
        can_display: false,
      };

      switch (this.source) {
        case "APPROVALS_PAGE":
          capability = {
            can_cancel: false,
            can_add: false,
            can_display: false,
          };
          break;
        case "MEETING_MODE":
          capability = {
            can_cancel: false,
            can_add: false,
            can_display: false,
          };
          break;
        default:
          capability = {
            can_cancel: true,
            can_add: true,
            can_display: true,
          };

      }

      return capability;
    },
    timelineClass() {
      // Check if all segments are cancelled
      if (this.trip.segments && this.trip.segments.length > 0) {
        const allCancelled = this.trip.segments.every(segment => segment.status === 'cancelled');
        if (allCancelled) {
          return 'is-info';
        }
      }

      if (this.trip.deniedAt) {
        return 'is-danger';
      }
      return 'is-warning';
    },
    timelineMessage() {
      // Check if all segments are cancelled
      if (this.trip.segments && this.trip.segments.length > 0) {
        const allCancelled = this.trip.segments.every(segment => segment.status === 'cancelled');
        if (allCancelled) {
          return 'This trip was cancelled.';
        }
      }

      if (this.trip.tripProgress) {
        const approvedStage = this.trip.tripProgress.find((stage) => stage.slug === 'approval');
        const approvalDeadline = this.trip.policy.approvalDeadline;
        if (approvedStage && !approvedStage.isComplete) {
          if (this.trip.policy.mostStrictApprovalRequired === 'HARD') {
            return `Your trip requires approval. It must be approved by ${this.formatApprovalDateString(approvalDeadline)} or it will be canceled.`;
          } else if (this.trip.policy.mostStrictApprovalRequired === 'SOFT') {
            return `Your trip is pending approval. If it is not approved by ${this.formatApprovalDateString(approvalDeadline)} it will be automatically approved and ticketed.`;
          }
        }

        if (this.trip.deniedAt) {
          return `Your trip was denied on ${this.formatApprovalDateString(this.trip.deniedAt)}.`;
        }
      }
      return null;
    },
    loggedInAccountId(){
      if(this.source == ""){
        return this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"].account.id
      }
      return null
    },
    hasActiveTripSegment(){
      return (this.trip.segments || []).some(segment => segment.status === 'active')
    }
  },
  methods: {
    pushToHotelSearch() {
      this.$store.dispatch("bookTravel/clearBooking");
      this.$store.dispatch("bookTravel/setTripResult", this.trip);

      router.push({
        name: "BookingHotels",
        //params: { recordLocator: this.trip.recordLocator, tripProp: this.trip },
      });
    },
    pushToCarSearch() {
      this.$store.dispatch("bookTravel/clearBooking");
      this.$store.dispatch("bookTravel/setTripResult", this.trip);

      router.push({
        name: "BookingCars",
        //params: { recordLocator: this.trip.recordLocator, tripProp: this.trip },
      });
    },
    pushToTripCancel(preSelected = null) {
      router.push({
        name: "TripCancel",
        params: {
          recordLocator: this.trip.recordLocatorHash,
          tripProp: this.trip,
          preSelectedSegment: preSelected,
        },
      });
    },
    async getTrip() {
      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/FlightTST2-Ticketed.xml",
          normalizeResponse: true,
        },

        recordLocator: this.recordLocator,
        officeId: this.$globals.profile.officeId,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/show",
        post
      );

      return result;
    },
    async init() {
      let result = await this.getTrip();
      this.trip = result.data;

      // Update isAuthorized after fetching the trip data
      this.isAuthorized = this.checkAuthorization();

      // Load resources if user is not logged in
      this.loadResources();

    },
    formatApprovalDateString(dateString) {
      // Parse the date string into a Date object

      if (dateString) {

        // API times are UTC without a zone marker; append "Z" so they are not read as local time.
        const isZonelessServerTime = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(dateString);
        const date = new Date(isZonelessServerTime ? dateString.replace(' ', 'T') + 'Z' : dateString);

        if (isNaN(date)) {
          return 'the approval deadline';
        }

        const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-based month, so add 1
        const day = date.getUTCDate();
        const year = date.getUTCFullYear().toString().slice(-2); // Get the last two digits of the year

        // Extract hours and minutes
        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // Pad minutes with leading zero if needed
        const ampm = hours >= 12 ? 'pm' : 'am'; // Determine am/pm
        hours = hours % 12; // Convert 24-hour format to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'

        // Format the date and time
        const formattedDate = `${month}/${day}/${year}`;
        const formattedTime = `${hours}:${minutes}${ampm}`;

        return `${formattedDate} ${formattedTime} UTC`;
      }else{
        return 'the approval deadline'
      }

    },
    checkAuthorization() {
      const alwaysAuthorizedSources = ["APPROVALS_PAGE", "MEETING_MODE"];

      return alwaysAuthorizedSources.includes(this.source) || this.loggedInAccountId === this.trip.account.salesforceId;
    },
    loadResources() {
      // If user is not logged in we need to load resources
      if (!this.loggedInAccountId) {
        // Get list of vendors
        this.$app.huddleLabsServerCall("resources/vendors").then((result) => {
          this.$store.dispatch("bookTravel/vendors", result);
        });

        // Get list of other resource options
        this.$app.huddleLabsServerCall("resources/options").then((result) => {
          this.$store.dispatch("options/setOptions", result.data);
        });

        // Get list of airports
        this.$app
          .huddleLabsServerCall("resources/airports?mode=advanced")
          .then((result) => {
            let airports = result.data;
            this.$store.dispatch("bookTravel/airports", airports);
          });
      }
    }
  },
  watch: {
    async $route(to, from) {
      this.loading = true;
      await this.init();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    if (this.tripProp && typeof this.tripProp === "object") {
      this.trip = this.tripProp;
    } else {
      await this.init();
    }
    this.loading = false;
  },
};
</script>

<style>
.type-panel {
  border: 1px rgb(226, 223, 223) solid;
  border-radius: 6px;
}

.section-title {
  border-bottom: 1px solid #ddddde;
  padding: 24px 32px;
  position: relative;
  top: 1px;
}

.section-body {
  padding: 24px 32px;
  position: relative;
  top: 1px;
}

.segment-divider {
  margin-top: 1px;
  margin-bottom: 10px;
  border: none;
  height: 1px;
  /* Set the hr color */
  color: #ddddde;
  /* old IE */
  background-color: #ddddde;
  /* Modern Browsers */
}

.li__icon {
  margin-right: 16px;
  -webkit-box-flex: 0;
  flex-grow: 0;
  font-size: 1.5rem;
}

.li__icon svg {
  width: 24px;
}

ul.list-unstyled {
  list-style-type: none;
  margin-left: 0;
}
</style>
